import { ReactNode } from 'react';
import { Paper, SxProps, TypographyOwnProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { NoDataGuard, useNoDataContainerStyles } from '../NoDataGuard';
import { ScrollableContainer } from '../ScrollableContainer';
import { Title } from '../Title';
import { BaseTableData } from '../../types';
import { DataTable } from './components/DataTable';
import { useBaseTableStyles } from './useTableWidgetStyles';

interface BaseTableProps {
  NoDataPlaceholder?: typeof NoDataGuard;
  className?: string;
  data: BaseTableData[];
  headingTitles: string[] | JSX.Element[];
  isLoading?: boolean;
  sx?: SxProps<Theme>;
  title?: string;
  dataTableTypographyVariant?: TypographyOwnProps['variant'];
  children?: JSX.Element;
  csvDownloadButton?: ReactNode;
}

export const BaseTable = ({
  NoDataPlaceholder = NoDataGuard,
  className,
  data,
  headingTitles,
  isLoading,
  sx,
  title,
  dataTableTypographyVariant,
  children,
  csvDownloadButton,
}: BaseTableProps) => {
  const { cx, classes } = useBaseTableStyles();

  const {
    classes: { container },
  } = useNoDataContainerStyles();

  return (
    <Paper
      sx={sx}
      className={cx(classes.root, className, {
        [container]: data.length === 0,
      })}
    >
      {title && (
        <Title className={classes.title} csvButton={csvDownloadButton}>
          {title}
        </Title>
      )}
      <NoDataPlaceholder data={data} isLoading={isLoading}>
        <ScrollableContainer>
          {children}
          <DataTable
            data={data}
            variant={dataTableTypographyVariant}
            headingTitles={headingTitles}
          />
        </ScrollableContainer>
      </NoDataPlaceholder>
    </Paper>
  );
};
